import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OccEndpointsService } from '@spartacus/core';
import { Observable } from 'rxjs';
import {
  CheckoutData,
  PlaceOrderForm,
  PlaceOrderResponse,
} from './uig-checkout.models';

@Injectable()
export class UigCheckoutAdapter {
  constructor(
    protected http: HttpClient,
    protected occEndpoints: OccEndpointsService
  ) {}

  placeOrder(
    userId: string,
    cartId: string,
    placeOrderForm: PlaceOrderForm
  ): Observable<PlaceOrderResponse> {
    const params = new HttpParams().set('cartId', cartId);
    return this.http.post<PlaceOrderResponse>(
      this.occEndpoints.buildUrl('placeOrder', {urlParams: {userId}}),
      placeOrderForm,
      { params }
    );
  }

  checkoutData(userId: string, cartId: string): Observable<CheckoutData> {
    const params = new HttpParams().set('cartId', cartId);
    return this.http.get<CheckoutData>(
      this.occEndpoints.buildUrl('uigcheckout/checkoutData', {queryParams: { userId }}),
      { params }
    );
  }
}
